/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ReportCrashResult = {
  /**
   * Reports accepted. A report not shaped like a device agent crash is dropped and not counted. The agent removes every report in the batch on success.
   */
  accepted: number;
};

/** @internal */
export const ReportCrashResult$inboundSchema: z.ZodMiniType<
  ReportCrashResult,
  unknown
> = z.object({
  accepted: z.int(),
});

export function reportCrashResultFromJSON(
  jsonString: string,
): SafeParseResult<ReportCrashResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ReportCrashResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ReportCrashResult' from JSON`,
  );
}
